import { render, staticRenderFns } from "./aspectCorreos.vue?vue&type=template&id=42ec0c57&scoped=true&"
import script from "./aspectCorreos.vue?vue&type=script&lang=js&"
export * from "./aspectCorreos.vue?vue&type=script&lang=js&"
import style0 from "./aspectCorreos.vue?vue&type=style&index=0&id=42ec0c57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec0c57",
  null
  
)

export default component.exports